
export default [
    require('./feature-storage'),
    require('./feature-network'),
    require('./feature-stacklayout'),
    require('./feature-auth'),
    require('./feature-links'),
    require('./feature-tutorials'),
]
